// extracted by mini-css-extract-plugin
module.exports = {"HouseBrandMenu":"houseBrandMenu_HouseBrandMenu__m_tx_","topic":"houseBrandMenu_topic__XSbVb","heading":"houseBrandMenu_heading__xx4E2","link":"houseBrandMenu_link__QyN9e"};